var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { FilterData } from 'path-shared/models/filter-data';
var TurnosFilter = /** @class */ (function (_super) {
    __extends(TurnosFilter, _super);
    function TurnosFilter(sortField, sortDir) {
        var _this = _super.call(this, sortField, sortDir) || this;
        _this.descripcion = '';
        _this.hora_inicio = null;
        _this.hora_fin = null;
        _this.labels['descripcion'] = _this.i18n('Descripció');
        _this.labels['hora_inicio'] = _this.i18n('Hora inici');
        _this.labels['hora_fin'] = _this.i18n('Hora fi');
        return _this;
    }
    return TurnosFilter;
}(FilterData));
export { TurnosFilter };
